<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="用户注册"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onBatchSubmit" ref="activeFormRef">
        <div class="main-info-wrap">
          <div class="main-info-title">个人信息</div>
          <!-- 姓名 -->
          <van-field
              v-model.trim="mainForm.name"
              name="name"
              label="姓名"
              placeholder="请输入姓名"
              required
              trigger="blur"
              :rules="[{ required: true }]"
          />
          <!-- 手机号 -->
          <div class="phone-tip">港澳台手机号必须带对应区号（如+852/+853/+886）</div>
          <van-field
              v-model.trim="mainForm.phone"
              name="phone"
              label="手机号"
              placeholder="请输入手机号"
              type="tel"
              required
              :rules="[{ required: true }, { pattern: mobileReg, message: '请输入合法的手机号' }]"
          />

          <!-- 验证码 -->
          <div class="code-input-wrap">
            <van-field
                v-model.trim="mainForm.code"
                name="code"
                label="验证码"
                placeholder="请输入验证码"
                required
                :rules="[{ required: true, message: '请输入验证码' }]"
            />
            <van-button
                class="code-btn"
                size="small"
                type="primary"
                plain
                @click.prevent="getCode"
                :disabled="codeDisabled"
            >
              {{ codeBtnText }}
            </van-button>
          </div>

          <van-field
              readonly
              clickable
              name="address"
              :value="provinceValue"
              label="通讯地址"
              placeholder="点击选择省市区（选填）"
              @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                @confirm="onCityConfirm"
                @cancel="showArea = false"
            />
          </van-popup>

          <!-- 密码 -->
          <van-field
              v-model.trim="mainForm.password"
              name="password"
              label="密码"
              type="password"
              placeholder="请输入6-16位密码"
              required
              trigger="blur"
              maxlength="16"
              :rules="[
              { required: true },
              { pattern: /^.{6,16}$/, message: '请输入6-16位密码' }
            ]"
          />
          <!-- 确认密码 -->
          <van-field
              v-model.trim="mainForm.confirmPassword"
              name="confirmPassword"
              label="确认密码"
              type="password"
              placeholder="请再次输入密码"
              required
              maxlength="16"
              @blur="checkPwdSame"
              trigger="blur"
              :rules="[{ required: true }]"
          />
        </div>

        <!-- 提交按钮 -->
        <div style="margin: 16px;">
          <van-button class="submit-btn" round block type="info" native-type="submit">
            注册
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { Dialog, Toast } from 'vant';
import { memberRegister, sendRegisterCode } from '@/api/sales';
import { areaList } from '@vant/area-data';

export default {
  data() {
    return {
      provinceValue: '',
      showArea: false,
      areaList,
      mainForm: {
        name: '',
        phone: '',
        code: '',
        address: '',
        password: '',
        confirmPassword: ''
      },
      mobileReg: /^(?:(?:\+|00)86)?1[3-9]\d{9}$|^(?:\+|00)852[569]\d{7}$|^(?:\+|00)8536\d{7}$|^(?:\+|00)8869\d{8}$/,
      codeDisabled: false,
      codeBtnText: '获取验证码',
      codeTimer: null
    };
  },
  methods: {
    onCityConfirm(values) {
      this.provinceValue = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/');
      this.mainForm.address = this.provinceValue;
      this.showArea = false;
    },
    checkPwdSame() {
      const { password, confirmPassword } = this.mainForm;
      if (password && confirmPassword && password !== confirmPassword) {
        Toast('两次输入的密码不一致');
      }
    },
    onClickLeft() {
      this.$router.push('/app_home');
    },
    showDialogMsg(message) {
      Dialog.alert({
        title: '提示',
        message
      });
    },
    // 获取验证码【已对接接口】
    async getCode() {
      // 只校验手机号格式，不触发表单全部校验
      if (!this.mobileReg.test(this.mainForm.phone)) {
        Toast('请输入正确的手机号');
        return;
      }

      try {
        // 调用发送验证码接口
        const res = await sendRegisterCode(this.mainForm.phone);

        if (res.code === 200) {
          this.codeDisabled = true;
          let count = 60;
          this.codeBtnText = `${count}s 重新获取`;

          this.codeTimer = setInterval(() => {
            count--;
            if (count <= 0) {
              clearInterval(this.codeTimer);
              this.codeDisabled = false;
              this.codeBtnText = '获取验证码';
            } else {
              this.codeBtnText = `${count}s 重新获取`;
            }
          }, 1000);
          Toast(res.returnMsg || '验证码发送成功');
        } else {
          Toast(res.returnMsg || '验证码发送失败');
        }
      } catch (error) {
        Toast('验证码发送失败，请稍后重试');
      }
    },
    async onBatchSubmit() {
      try {
        await this.$refs.activeFormRef.validate();
        const { password, confirmPassword } = this.mainForm;
        if (password !== confirmPassword) {
          this.showDialogMsg('两次输入的密码不一致，请重新输入');
          return;
        }
        const formData = new FormData();
        formData.append('userName', this.mainForm.name);
        formData.append('phoneNumber', this.mainForm.phone);
        formData.append('captcha', this.mainForm.code);
        formData.append('address', this.mainForm.address.replaceAll('/', '') || '');
        formData.append('password', this.mainForm.password);

        const res = await memberRegister(formData);
        if (res.code === 200) {
          Toast(res.returnMsg || '注册成功');
          this.mainForm = {
            name: '',
            phone: '',
            code: '',
            address: '',
            password: '',
            confirmPassword: ''
          };
          setTimeout(() => {
            this.$router.push('/app_login');
          }, 1000);
        } else {
          Toast(res.returnMsg || '注册失败，请重试');
        }
      } catch (error) {
        if (error.name === 'ValidateError') {
          Toast('请检查所有必填项是否填写正确');
        } else {
          Toast('提交失败，请稍后重试');
        }
      }
    }
  },
  beforeDestroy() {
    if (this.codeTimer) clearInterval(this.codeTimer);
  }
};
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}

::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}

.container-item {
  margin-bottom: 60px;
  padding: 0 8px;
}

.submit-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}

.main-info-wrap {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  margin: 15px;

  @media (min-width: 768px) {
    padding: 15px 70px;
  }

  .main-info-title {
    font-size: 18px;
    font-weight: bold;
    color: #222;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;

    @media (min-width: 768px) {
      font-size: 30px;
      margin-bottom: 10px;
      padding-bottom: 10px;
    }
  }

  .phone-tip {
    font-size: 12px;
    color: #999;
    margin: 8px 0 4px 0;
    padding-left: 4px;

    @media (min-width: 768px) {
      font-size: 15px;
    }
  }
}

::v-deep .van-field__control {
  min-height: auto;
}

/* 获取验证码按钮文字改成黑色 */
::v-deep .van-button--primary.van-button--plain {
  color: #000 !important;
}
::v-deep .van-button--primary.van-button--plain:disabled {
  color: #ccc !important;
  border-color: #eee !important;
}

/* 验证码输入框容器 */
.code-input-wrap {
  position: relative;
}

/* 验证码输入框 */
.code-input-wrap .van-field {
  padding-right: 120px !important;
}

/* 获取验证码按钮 */
.code-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #000 !important;
  max-width: 100px;
  height: 28px !important;
  line-height: 26px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px !important;
  font-size: 12px !important;
}

.code-btn:disabled {
  color: #ccc !important;
  border-color: #eee !important;
}

/* PC端适配 */
@media (min-width: 768px) {
  .code-input-wrap .van-field {
    padding-right: 140px !important;
  }
  
  .code-btn {
    right: 15px;
    max-width: 110px;
    height: 32px !important;
    line-height: 30px !important;
    font-size: 14px !important;
    padding: 0 12px !important;
  }
}
</style>